import React from 'react';
import './AdminLoading.css';

export function AdminLoading({ title = "Loading Admin Panel", subtitle = "Setting up administrative tools..." }) {
  return (
    <div className="admin-loading">
      <div className="admin-loading-content">
        <div className="admin-loading-spinner">
          <i className="fa-solid fa-cog fa-spin"></i>
        </div>
        <div className="admin-loading-text">
          <h2 className="admin-loading-title">{title}</h2>
          <p className="admin-loading-subtitle">{subtitle}</p>
        </div>
      </div>
    </div>
  );
}